import { toast as reactToast } from 'react-toastify';

import { getToastMessage } from 'components/shared/ToastContainer/ToastMessage';

export const toast = {
    info: (title: string, message: string) => {
        reactToast.info(getToastMessage({title, message}));
    },
    success: (title: string, message: string) => {
        reactToast.success(getToastMessage({title, message}));
    },
    error: (title: string, message: string) => {
        reactToast.error(getToastMessage({title, message}));
    },
    warning: (title: string, message: string) => {
        reactToast.warning(getToastMessage({title, message}));
    },
    default: (title: string, message: string) => {
        reactToast(getToastMessage({title, message}));
    },
    dark: (title: string, message: string) => {
        reactToast.dark(getToastMessage({title, message}));
    }
};

export const showNotSupportedToast = () => {
    toast.info('Feature Not Supported', 'This feature is not supported yet, but is coming soon.');
};